<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <h2 class="panel-title mt-6">Ayuda</h2>
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <h2 class="panel-title  mt-6">Ajuda</h2>
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <h2 class="panel-title mt-6">Centro de Ayuda</h2>
      <div id="support" class="card-item">
        <h3 v-if="user.rol === 'CLIENT'">Gestiona tus consultas</h3>
        <div v-if="user.rol === 'CLIENT'" id="new-ticket" class="card-item shadowless">
          <h4>
            Nueva consulta
            <button class="button is-button-secondary is-pulled-right is-rounded" @click="hideNewTicketForm">
              <i class="fas" :class="isFormHidden ? 'fa-edit' : 'fa-times'" />
            </button>
          </h4>
          <transition name="slide">
            <div v-if="!isFormHidden" id="form-body">
              <div class="form-support">
                <p class="subtitle">
                  ¿Necesitas ayuda? Escríbenos si presentas algún problema y nuestros especialistas te
                  atenderán lo más pronto posible.
                </p>
                <form action="" class="inline" @submit.prevent="createNewTicket()">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label subject-label">
                        <b-select id="select-ticket-subject" v-model="inputSubject" size="is-small" rounded>
                          <option v-for="(dictionaryValue, subject) in subjectsDictionary" :key="subject" :value="subject">
                            {{ dictionaryValue }}
                          </option>
                        </b-select>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <textarea
                            id="textarea-ticket-text"
                            v-model="inputMessage"
                            class="textarea question-box"
                            placeholder="Escribe tu consulta" />
                        </div>
                        <p v-if="errors.message" class="help is-danger">{{ errors.message }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="field is-horizontal">
                    <div class="field-label">
                      <!-- Left empty for spacing -->
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <button id="button-create-ticket" class="button is-button-primary is-pulled-right is-rounded" type="submit">
                            Enviar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="image-support">
                <img src="@/ui/assets/img/support.svg" alt="">
              </div>
            </div>
          </transition>
        </div>
        <div id="support-history">
          <h4 class="history-support-title">
            Historial de consultas
            <div class="field is-pulled-right">
              <div class="control select is-rounded is-small">
                <select id="select-filter" v-model="filteredStatus" @change="renderTickets">
                  <option
                    v-for="(status, key) in statusDictionary"
                    :key="key"
                    :value="key"
                    :selected="key === filteredStatus">
                    {{ status }}
                  </option>
                </select>
              </div>
            </div>
          </h4>
          <div class="spinner-content" :class="isLoading ? 'is-loading' : 'is-hidden'">
            <div class="spinner">
              <div class="double-bounce1" />
              <div class="double-bounce2" />
            </div>
          </div>
          <transition-group
            v-if="!isLoading"
            name="tickets-transition"
            class="tickets"
            appear
            tag="div">
            <div :key="`ticket`">
              <b-table
                :row-class="(row, i) => `help-ticket-${i}`"
                detailed
                hoverable
                :data="filteredTickets">
                <b-table-column v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support')" v-slot="ticket" field="name">
                  {{ ticket.row.client.name }} {{ ticket.row.client.lastName }}
                </b-table-column>
                <b-table-column v-slot="ticket" field="subject">
                  <span class="tag subject-tag is-primary is-light is-size-6"><i v-if="!ticket.row.isPublic" class="fa fa-house-user fa-lg is-private mr-2" title="Ticket privado" />
                    {{ subjectsDictionary[ticket.row.subject] || ticket.row.subject }}</span>
                </b-table-column>
                <b-table-column v-slot="ticket" field="date">
                  <i class="far fa-calendar fa-lg has-text-primary mr-1" title="Fecha de creación" />{{ formatDate(ticket.row.createdAt) }}
                </b-table-column>
                <b-table-column v-slot="ticket" field="status">
                  <div class="round-content">
                    <div class="round-color" :class="ticket.row.status" />
                  </div>
                </b-table-column>

                <template #detail="ticket">
                  <div :id="`jajaja-${index}`" :key="index" class="ticket-details clearfix transition-slow show">
                    <ul class="is-size-7 meta-data">
                      <li>
                        <b>N° de atención:</b><br>
                        #{{ ticket.row._id }}
                      </li>
                      <li v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support')">
                        <b>RUT:</b><br>
                        {{ formatRut(ticket.row.client.idNumber) }}
                      </li>
                      <li v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support')">
                        <b>Teléfono:</b><br>
                        {{ ticket.row.client.phone }}
                      </li>
                      <li v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support')" id="li-email">
                        <b>Mail:</b><br>{{ ticket.row.client.email }}
                      </li>
                      <li v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support') && ticket.row.client.balance">
                        <b>Saldo:</b><br>
                        {{ formatNumber(ticket.row.client.balance) }}
                      </li>
                    </ul>
                    <div v-for="(message, j) in ticket.row.messages" :key="j" class="ticket-message">
                      <div class="is-clearfix">
                        <span class="title is-6 is-pulled-left" :class="message.from">
                          {{ getClientName(user, message, ticket.row) }}
                        </span>
                        <span class="is-size-7 date-support-message is-pulled-right">
                          {{ formatDate(message.createdAt, 'DD/MM/YYYY[ a las ]HH:MM:ss') }}
                        </span>
                      </div>
                      <p :id="`help-ticket-text-${j}`" class="user-message">{{ message.text }}</p>
                      <hr>
                    </div>
                    <div class="buttons is-right ticket-buttons">
                      <b-button
                        v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support') && ticket.row.subject !== 'CONTACT_CHANGE' && ticket.row.status !== 'CLOSED'"
                        :id="`button-close-${0}`"
                        class="customer-button"
                        rounded
                        size="is-small"
                        @click="confirmToCloseTicket(ticket.row._id)">
                        Cerrar
                      </b-button>
                      <b-button
                        v-if="ticket.row.status !== 'CLOSED' && ticket.row.subject !== 'CONTACT_CHANGE'"
                        id="button-answer"
                        :disabled="!checkUserFeature('element.support.button.responder')"
                        rounded
                        class="is-button-primary"
                        size="is-small"
                        @click="launchModalMessage(ticket.row._id)">
                        Responder
                      </b-button>
                      <b-button
                        v-if="ticket.row.status !== 'CLOSED' && ticket.row.subject === 'CONTACT_CHANGE'"
                        :id="`button-rejected-${0}`"
                        class="customer-button"
                        rounded
                        size="is-small"
                        @click="rejectEmailChange(ticket.row)">
                        Rechazar
                      </b-button>
                      <b-button
                        v-if="ticket.row.status !== 'CLOSED' && ticket.row.subject === 'CONTACT_CHANGE'"
                        id="button-answer"
                        rounded
                        class="is-button-primary"
                        size="is-small"
                        @click="checkEmailContact(ticket.row)">
                        Validar
                      </b-button>
                      <p v-if="ticket.row.status === 'CLOSED'" class="is-size-7">
                        Esta consulta está cerrada, si quieres retomarla por favor crea una nueva indicando el N° de Atención.
                      </p>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </transition-group>
          <div v-if="!filteredTickets.length" class="mt-5 mb-5" style="margin:auto;display:table;">Tickets no disponibles.</div>
        </div>
      </div>
      <b-modal v-model="isModalActive">
        <div class="modal-card-body">
          <div>
            <a class="close-modal" @click="isModalActive=false">
              <img src="@/ui/assets/img/plus-button.svg">
            </a>
          </div>
          <h3 class="modal-title">Responder</h3>
          <section class="modal-card-body">
            <div class="field">
              <label class="label">Mensaje</label>
              <div class="control">
                <textarea id="textarea-answer" v-model="newMessageForm.message" class="textarea" />
              </div>
            </div>
            <label v-if="user.rol !== 'CLIENT' && checkUserFeature('element.support.customer-support')" class="checkbox">
              <input id="checkbox-close-ticket" v-model="newMessageForm.closeCurrentTicket" type="checkbox">
              Además cerrar consulta
            </label>
          </section>
          <b-button
            id="button-send-answer"
            class="is-button-primary is-pulled-right"
            rounded
            @click="addNewReply()">
            Responder
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  getHelpTickets,
  createHelpTicket,
  closeHelpTicket,
  closeHelpTicketWithoutEmail,
  addMessageToHelpTicket,
  getSubjectsDictionary
} from '@/application/services/api-clients/help-tickets';
import { authenticationService } from '@/application/services/api-clients/login-service';
import { dateToFormatedString } from '@/infrastructure/date';
import userFeatures from '@/ui/mixins/user-features';
import Message from '@/ui/components/Message.vue';
import { formatNumber } from '@/infrastructure/format';

export default {
  components: { Message },
  mixins: [userFeatures],
  data() {
    return {
      tickets: [],
      filteredTickets: [],
      isLoading: true,
      extendedTicket: undefined,
      errors: {
        subject: '',
        message: ''
      },
      inputMessage: '',
      inputSubject: '',
      user: this.$store.state.currentUser.user,
      isModalActive: false,
      newMessageForm: {
        message: '',
        currentTicket: '',
        closeCurrentTicket: false
      },
      statusDictionary: {
        OPEN: 'Abiertos',
        CLOSED: 'Resueltos',
        UNASSIGNED: 'Pendientes',
        ALL: 'Todos'
      },
      filteredStatus: 'UNASSIGNED',
      isFormHidden: false,
      subjectsDictionary: {}
    };
  },
  async mounted() {
    if (this.$i18n.locale === 'cl') {
      this.getSubjectsDictionary();
      this.updateTickets();
    }
  },
  methods: {
    async updateTickets() {
      this.isLoading = true;
      try {
        this.tickets = await getHelpTickets();
      } catch (error) {
        this.alert({ message: error });
        this.isLoading = false;
        return;
      }
      this.renderTickets();
      this.isLoading = false;
    },
    async renderTickets() {
      this.filteredTickets = [];
      await this.$nextTick(); // https://vuejs.org/v2/guide/reactivity.html#Async-Update-Queue
      this.extendedTicket = this.extendedTicket === 0 ? this.extendedTicket : undefined;
      if (this.filteredStatus === 'ALL') {
        this.filteredTickets = this.getTicketsFormatted();
        return;
      }
      this.filteredTickets = (this.getTicketsFormatted()).filter(ticket => ticket.status === this.filteredStatus);
    },
    getTicketsFormatted() {
      return this.tickets.map(ticket => {
        return !ticket.clientUserId
          ? Object.assign(
            ticket,
            {
              client: {
                name: ticket.unknownUser.firstName,
                lastName: ticket.unknownUser.lastName,
                idNumber: ticket.unknownUser.idNumber,
                phone: ticket.unknownUser.phone,
                email: ticket.unknownUser.email,
                balance: null
              },
              isPublic: true
            }
          ) : ticket;
      });
    },
    formatDate: (date, format = 'DD/MM/YYYY') => dateToFormatedString(date, format),
    formatNumber: number => formatNumber({ number }),
    formatRut(rut) {
      const rutParts = rut.split('-');
      return `${this.formatNumber(Number(rutParts[0]))}-${rutParts[1]}`;
    },
    async createNewTicket() {
      this.errors.message = '';
      this.errors.subject = '';
      if (!this.inputSubject) {
        this.errors.subject = 'Debes seleccionar un asunto';
        return;
      }
      if (!this.inputMessage) {
        this.errors.message = 'Por favor describe tu consulta';
        return;
      }
      try {
        await createHelpTicket(this.inputSubject, this.inputMessage);
      } catch (error) {
        this.errorAlert(error.response.data.message);
      }

      this.inputMessage = '';
      this.inputSubject = '';
      this.filteredStatus = 'UNASSIGNED';
      this.isFormHidden = true;
      this.extendedTicket = 0;
      await this.updateTickets();
    },
    async checkEmailContact(ticket) {
      if (ticket.client) {
        const result = authenticationService.restoreEmail(ticket.client.idNumber, ticket.client.email);
        if (result) {
          await closeHelpTicketWithoutEmail(ticket._id);
          this.updateTickets();
        }
        return result;
      }
      return false;
    },
    async rejectEmailChange(ticket) {
      if (ticket.client) {
        const result = authenticationService.rejectEmailChange(ticket.client.idNumber, ticket.client.email);
        if (result) {
          await closeHelpTicketWithoutEmail(ticket._id);
          this.updateTickets();
        }
        return result;
      }
      return false;
    },
    launchModalMessage(ticketId) {
      this.newMessageForm.currentTicket = ticketId;
      this.newMessageForm.closeCurrentTicket = false;
      this.newMessageForm.message = '';
      this.isModalActive = true;
    },
    async addNewReply() {
      try {
        await addMessageToHelpTicket(
          this.newMessageForm.currentTicket,
          this.newMessageForm.message,
          this.newMessageForm.closeCurrentTicket
        );
      } catch (error) {
        this.errorAlert(error.response.data.message);
      }
      await this.updateTickets();
      this.extendedTicket = 0;
      // Los nuevos tickets vienen ordenados por fecha de actualizacion, por eso
      // extiendo el primero del arreglo
      this.isModalActive = false;
    },
    confirmToCloseTicket(ticketId) {
      this.$buefy.dialog.confirm({
        title: 'Confirmar',
        message: '¿En serio?',
        cancelText: 'Cancelar',
        confirmText: 'Confirmar cierre',
        type: 'is-info',
        onConfirm: () => this.setAsClosed(ticketId)
      });
    },
    async setAsClosed(ticketId) {
      try {
        await closeHelpTicket(ticketId);
      } catch (error) {
        this.errorAlert(error.response.data.message);
      }
      this.updateTickets();
    },
    hideNewTicketForm() {
      this.isFormHidden = !this.isFormHidden;
    },
    async getSubjectsDictionary() {
      const subjectsFromBackend = await getSubjectsDictionary();
      this.subjectsDictionary = subjectsFromBackend;
    },
    getClientName(user, message, ticket) {
      const ROLES = {
        CLIENT: 'CLIENT',
        UNKNOWN: 'UNKNOWN'
      };
      if (user.rol === ROLES.UNKNOWN || !ROLES[user.rol]) {
        return '';
      }
      if (user.rol === ROLES.CLIENT && message.from === ROLES.CLIENT) {
        return user.name;
      }
      if (message.from === ROLES.CLIENT) {
        return ticket.client.name;
      }
      if (message.from === ROLES.UNKNOWN && ticket.unknownUser) {
        return `${ticket.unknownUser.firstName} ${ticket.unknownUser.lastName}`;
      }
      return 'Soporte';
    },
    errorAlert(text) {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: text,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      });
    }
  }
};
</script>

<style scoped>
  .close-modal {
    position: absolute;
    right: 20px;
    top:20px;
    width: 40px;
  }
  h4 {
    color: var(--color-nickel);
  }
  .spinner-content {
    padding: 40px 0;
  }
  #form-body {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    height: calc(100%);
    align-items: center;
  }
  .form-support {
    width: calc(70% + 40px);
    margin: 20px;
  }
  .image-support {
    width: calc(20% + 20px);
    text-align: center;
  }
  #support h3 {
    text-align: center;
  }
  #new-ticket p {
    font-size: 12px;
  }
  .subject-color {
    background-color:#EFEFEF;
  }
  .question-box{
    border-radius: 20px;
    background-color: #EFEFEF;
  }
  .textarea:focus {
    border-color: #4d4d4d;
  }
  .history-support-title {
    padding: 15px;
  }
  .ticket {
    padding: 14px 29px;
    margin: 1.5rem auto;
    border-radius: 25px;
    position: relative;
    overflow: inherit;
    width: 100%;
  }
  .ticket-info {
    font-size: 14px;
  }
  .creation-date i {
    color: var(--primary);
  }
  .is-private {
    color: var(--primary);
  }
  .subject-tag {
    max-width: 320px;
    overflow: hidden;
    justify-content: start;
  }
  .round-content {
    width: 25px;
    float: left;
  }
  .text-item-info {
    width: 30%;
    float: left;
    padding: 0px 20px;
    position: relative;
    min-height: 25px;
    text-align: center;
  }
  .text-item-info.ticket-title {
    width: calc(45%);
    color: var(--primary);
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding-left: 15px;
  }
  .details-content a {
    text-decoration: none;
    font-size: 16px;
  }
  .ticket-details {
    width: 100%;
    max-height: 0px;
    height: auto;
    overflow: hidden;
    margin: auto;
    margin-top: 0px;
    border-radius: 20px;
    padding: 0 30px;
    margin-top: 0px;
  }
  .meta-data {
    color: #00CCD1;
    margin-bottom: 15px;
    padding: 10px 20px;
    background-color:rgba(0,173,168,0.14);
    border-radius: 10px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
  }
  .meta-data li {
    text-align: center;
    margin: 5px 10px;
  }
  .ticket-details.show {
    margin-top: 10px;
    padding: 20px;
    max-height: 300px;
    overflow-y: auto;
  }
  .ticket-message {
    margin: 15px 0;
  }
  .ticket-message:last-of-type {
    margin-bottom: 0;
  }
  .ticket-message .title {
    margin-bottom: 0;
    color: var(--primary) ;
  }
  .ticket-message .title.CUSTOMER_SUPPORT {
    color: var(--secondary)
  }
  .ticket-message .user-message {
    white-space: pre-wrap;
    font-size: 14px;
    margin-top: 10px;
  }
  .button.is-rounded.customer-button {
    margin-left: 20px;
    padding-left: 2.5em;
    padding-right: 2.5em;
  }

  .round-color.OPEN { background-color: var(--yellow); }
  .round-color.CLOSED { background-color: var(--primary); }
  .round-color.UNASSIGNED { background-color: var(--color-silver); }

  @media (max-width: 870px) {
    .form-support {
      width: 100%;
      margin: 0px;
    }
    .image-support {
      display: none;
    }
    .subject-label {
      margin-bottom: 20px;
    }
    #new-ticket h4 button {
      padding: 10px;
      height: 30px;
    }
    .text-item-info.ticket-title {
      font-size: 14px;
    }
    .text-item-info {
    width: 40%;
    }
  }
  @media (max-width: 640px) {
    .ticket-info .text-item-info {
      float: none;
    }
    .text-item-info.ticket-title {
    width: 100%;
    margin: 10px 20px 0px;
    font-size: 16px;
    }
    .text-item-info.creation-date {
    width: 90%;
    margin: 10px 20px 0px;
    text-align: left;
    }
    .meta-data li {
      font-size: 10px;
    }
    .ticket-message .user-message {
    font-size: 12px;
    }
  }
  @media (max-width: 490px) {
    #support-history h4 {
      display: inline-block;
    }
    #support-history h4 .field {
      margin-top: 25px;
    }
    .meta-data li {
      font-size: 8px;
    }
    .customer-button {
      font-size: 10px;
    }
    .customer-close-button {
      font-size: 10px;
    }
    .meta-data p {
      font-size: 10px;
    }
  }
  @media (max-width: 350px) {
    .meta-data li {
      font-size: 6px;
    }
    .customer-button {
      font-size: 8px;
    }
    .customer-close-button {
      font-size: 8px;
    }
    .meta-data p {
      font-size: 8px;
    }
  }
  /* transition: slide */
  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }
  .slide-enter-to,
  .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter,
  .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }
  /* Transition tickets */
  /* https://codepen.io/shshaw/pen/YLmdxz */
  .tickets-transition-enter-active {
    transition: opacity 0.5s linear, transform 0.5s cubic-bezier(0.2, 0.5, 0.1, 1);
    transition-delay: calc( 0.1s * var(--i) );
  }
  .tickets-transition-enter, .tickets-transition-leave-to, .tickets-transition-leave-active {
    opacity: 0;
  }
  .tickets-transition-enter {
    transform: translateX(-1em);
  }
  .tickets-transition-leave-to {
    transform: translateX(1em);
  }

.capitalize-first-letter::first-letter {
  text-transform: capitalize;
}
</style>
